import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MustMatch } from 'src/app/data-service/must-match.validator';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { LoaderService } from '../shared.service';

@Component({
  selector: 'app-add-admin-wms-users',
  templateUrl: './add-admin-wms-users.component.html',
  styleUrls: ['./add-admin-wms-users.component.scss']
})
export class AddAdminWmsUsersComponent implements OnInit {
  private ResponseVerifiedGetAllEpcUser: Subject<any> = new Subject();
  isEditing: boolean = false;
  userId: any;
  addWmsForm: FormGroup;
  dataObject: { search: string; limit: number; offset: number; };
  adminEpcUserList: any;
  pipe = new DatePipe('en-US');
  editUserObject: { id: any; };
  addenergy_meter: any;
  energy_meter = false;
  marked = false;
  isdevice: number;
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService,
    private loaderService: LoaderService
  ) {
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }

  ngOnInit() {
    this.addWmsForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      emails: this.fb.array([
        this.createEmailField()
      ]),
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      sim_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      instd_capacity: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [Validators.pattern("^[a-zA-Z0-9]+$")]],
      num_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      area_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      eff_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_v: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_p: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      epc_id: ['', [Validators.required]],
      confirmPassword: ['', Validators.required],
      energy_meter: [''],
      graph_interval: [''],
    }, {
      validator: MustMatch('password', 'confirmPassword')
    }
    );
    this.getAllEpcUser();
    if (this.isEditing == true) {
      this.getInfoByUserId()
    }
  }

  get f() { return this.addWmsForm.controls; }

  // email form array
  get emails(): FormArray {
    return this.addWmsForm.get('emails') as FormArray;
  }

  createEmailField(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]]
    });
  }

  // add email
  addEmail(): void {
    this.emails.push(this.createEmailField());
  }

  // remove email
  removeEmail(index: number): void {
    this.emails.removeAt(index);
  }

  createEmailControls(emailArray) {
    for (let i = 1; i < emailArray.length; i++) {
      this.addEmail();
    }
  }

  onEpcChange(epc) {

  }
  // get alladmin epc user list
  getAllEpcUser() {
    this.dataObject = {
      search: '',
      limit: 0,
      offset: 0
    }
    this.dashbord.getAllEpcUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.adminEpcUserList = data.resultObject.sort((a: { name: string; }, b: { name: any; }) => a.name.localeCompare(b.name));

            // this.adminEpcUserList = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  add_wms() {
    if (this.addWmsForm.value.graph_interval == "") {
      this.graph_inv = "15";
    } else { this.graph_inv = this.addWmsForm.value.graph_interval; }
    if (this.addWmsForm.value.energy_meter == true || this.addWmsForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addWmsForm.value.energy_meter == false || this.addWmsForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    var wmsInfo =
    {
      "login_id": this.addWmsForm.controls['login_id'].value,
      "name": this.addWmsForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addWmsForm.controls['emails'].value),
      "password": this.addWmsForm.controls['password'].value,
      "mobile_no": this.addWmsForm.controls['mobile_no'].value,
      "address": this.addWmsForm.controls['address'].value,
      "sim_no": this.addWmsForm.controls['sim_no'].value,
      "instd_capacity": this.addWmsForm.controls['instd_capacity'].value,
      "num_inverter": this.addWmsForm.controls['num_inverter'].value,
      "elec_rate": this.addWmsForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addWmsForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addWmsForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addWmsForm.controls['solar_panel'].value,
      "num_solar_panel": this.addWmsForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addWmsForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addWmsForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addWmsForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addWmsForm.controls['t_coeff_p'].value,
      "epc_id": this.addWmsForm.controls['epc_id'].value,
      "is_emeter": this.addenergy_meter,
      "graph_interval": this.graph_inv

    }
    this.dashbord.AdminaddWms(wmsInfo)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-wms-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }
  getInfoByUserId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getAdminInfoByWmsUserId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.dataObject = data.resultObject;
            this.isdevice = this.dataObject[0].isdevice;

            var editEnergyMeter = data.resultObject[0].is_emeter;
            if (editEnergyMeter == 0) {
              this.marked = false;
              this.toggleVisibility(this.marked);
            } else if (editEnergyMeter == 1) {
              this.marked = true;
              this.toggleVisibility(this.marked);
            }
            if (this.isdevice) {
              this.addWmsForm.get('epc_id').disable();
            }

            const emails = this.loaderService.convertSrtingIntoArrayOfObj(this.dataObject[0].email);
            this.createEmailControls(emails);
            // set value on the from
            this.addWmsForm.get('login_id').setValue(data.resultObject[0].login_id);
            this.addWmsForm.get('name').setValue(this.dataObject[0].name);
            this.addWmsForm.get('emails').setValue(emails);
            this.addWmsForm.get('mobile_no').setValue(this.dataObject[0].mobile_no);
            this.addWmsForm.get('address').setValue(this.dataObject[0].address);
            this.addWmsForm.get('sim_no').setValue(this.dataObject[0].sim_no);
            this.addWmsForm.get('instd_capacity').setValue(this.dataObject[0].instd_capacity);
            this.addWmsForm.get('num_inverter').setValue(this.dataObject[0].num_inverter);
            this.addWmsForm.get('elec_rate').setValue(this.dataObject[0].elec_rate);
            this.addWmsForm.get('start_dt').setValue(this.dataObject[0].start_dt);
            this.addWmsForm.get('end_dt').setValue(this.dataObject[0].end_dt);
            this.addWmsForm.get('solar_panel').setValue(this.dataObject[0].solar_panel);
            this.addWmsForm.get('num_solar_panel').setValue(this.dataObject[0].num_solar_panel);
            this.addWmsForm.get('area_solar_panel').setValue(this.dataObject[0].area_solar_panel);
            this.addWmsForm.get('eff_solar_panel').setValue(this.dataObject[0].eff_solar_panel);
            this.addWmsForm.get('t_coeff_v').setValue(this.dataObject[0].t_coeff_v);
            this.addWmsForm.get('t_coeff_p').setValue(this.dataObject[0].t_coeff_p);
            this.addWmsForm.get('epc_id').setValue(this.dataObject[0].epc_id);
            this.addWmsForm.get('graph_interval').setValue(data.resultObject[0].graph_interval);
            this.addWmsForm.get('password').setValue("password");
            this.addWmsForm.get('confirmPassword').setValue("password");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // update wms user
  update_wms() {
    if (this.addWmsForm.value.energy_meter == true || this.addWmsForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addWmsForm.value.energy_meter == false || this.addWmsForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    var wmsInfo =
    {
      "id": this.userId,
      "login_id": this.addWmsForm.controls['login_id'].value,
      "name": this.addWmsForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addWmsForm.controls['emails'].value),
      "mobile_no": this.addWmsForm.controls['mobile_no'].value,
      "address": this.addWmsForm.controls['address'].value,
      "sim_no": this.addWmsForm.controls['sim_no'].value,
      "instd_capacity": this.addWmsForm.controls['instd_capacity'].value,
      "num_inverter": this.addWmsForm.controls['num_inverter'].value,
      "elec_rate": this.addWmsForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addWmsForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addWmsForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addWmsForm.controls['solar_panel'].value,
      "num_solar_panel": this.addWmsForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addWmsForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addWmsForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addWmsForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addWmsForm.controls['t_coeff_p'].value,
      "epc_id": this.addWmsForm.controls['epc_id'].value,
      "is_emeter": this.addenergy_meter,
      "graph_interval": this.addWmsForm.controls['graph_interval'].value,
    }
    this.dashbord.adminUpdateWmsUser(wmsInfo).pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-wms-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }
  toggleVisibility(e) {
    if (e == false) {
      this.marked = false;
      this.energy_meter = false;
    }
    else if (e == true) {
      this.marked = true;
      this.energy_meter = true;
    }
  }
  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser.next();
    this.ResponseVerifiedGetAllEpcUser.complete();
  }
  changeTime(e) {
  }
}
